import { Entity, NetworkArray, NetworkPaginationSlice } from 'typed/api/entities';
import { IReducer } from './';
import { IEntitySet, isNetworkArray } from './entityReducers';
import { deepAssign } from 'typed/utils';

// TODO less shitty name; it's a counterpart of DefaultSortColumn in backend

export default function sortedEntitiesReducer<E extends Entity, R extends IReducer<NetworkPaginationSlice<E>, any>>(def: NetworkPaginationSlice<E>, prop: keyof E, reducer: R): R;
export default function sortedEntitiesReducer<E extends Entity, R extends IReducer<NetworkArray<E>, any>>(def: NetworkArray<E>, prop: keyof E, reducer: R): R;
export default function sortedEntitiesReducer<E extends Entity, R extends IReducer<E[], any>>(def: E[], prop: keyof E, reducer: R): R;
export default function sortedEntitiesReducer<E extends Entity, R extends IReducer<IEntitySet<E>, any>>(def: IEntitySet<E>, prop: keyof E, reducer: R): R {
    return (function sortableEntitiesReducer(state: any = def, action: any): any {
        const
            oldState: any = state,
            newState: any = reducer(state, action);

        if (!oldState || newState === oldState) {
            return newState;
        }

        const newData = (isNetworkArray(newState) ? newState.Data : newState).copy().sortBy((entity: E) => {
            const comparisonValue = (entity as unknown as any)[prop];
            return typeof comparisonValue === 'string' ? comparisonValue.toLowerCase() : comparisonValue;
        });

        return isNetworkArray(newState) ? deepAssign(newState, { Data: newData }) : deepAssign(newState, newData);
    }) as any;
}

